module.exports = __webpack_public_path__ + "static/img/company.77fef7fe.webp";